import { createAsyncThunk } from "@reduxjs/toolkit";
import { CHARGING_NETWORKS } from "../../../API/UserApi";
import axios from "axios";
import apiHeader from "../../../Components/ApiHeader";

export const getWalletSettingsListAPI: any = createAsyncThunk(
  "getWalletSettingsList",
  async (params: any, { rejectWithValue }: any) => {
    const token: any = localStorage.getItem("token");
    const commonHead = apiHeader(token);
    try {
      const res = await axios.get(CHARGING_NETWORKS, {
        headers: commonHead,
        params: params,
      });
      return { walletSettings: res };
    } catch (error: any) {
      return rejectWithValue({
        error: { code: error.response.status, message: error.message },
      });
    }
  }
);
